var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_4136_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5022 7.33125C24.5365 8.50579 25.4357 10.8973 24.8047 13.0582L28.0045 13.9925C29.056 10.3912 27.5645 6.405 24.1688 4.4445C20.183 2.14332 15.0865 3.50895 12.7853 7.49472C10.7695 10.9862 11.5674 15.33 14.4755 17.9005L11.3387 23.3335H11.3333C9.4924 23.3335 8 24.826 8 26.6668C8 28.5078 9.4924 30.0002 11.3333 30.0002C13.1743 30.0002 14.6667 28.5078 14.6667 26.6668C14.6667 26.4012 14.6356 26.1427 14.5768 25.8948C14.4395 25.3158 14.4064 24.687 14.7039 24.1715L18.9455 16.8248L17.5022 15.9915C15.1107 14.6108 14.2913 11.5529 15.6721 9.16139C17.0528 6.76992 20.1107 5.95055 22.5022 7.33125ZM25.0525 30.1335C26.6083 31.7603 29.129 32.1775 31.1633 31.0028C33.5548 29.6222 34.3742 26.5643 32.9935 24.1728C31.6128 21.7813 28.5548 20.962 26.1633 22.3427L24.72 23.176L20.4777 15.828C20.1802 15.3126 19.6188 15.0269 19.0488 14.8563C18.8048 14.7833 18.5655 14.681 18.3355 14.5481C16.7412 13.6276 16.1949 11.589 17.1153 9.9947C18.0358 8.40039 20.0745 7.85414 21.6688 8.77462C23.2632 9.69509 23.8093 11.7337 22.8888 13.328L22.886 13.3329L26.0235 18.767C29.7037 17.5337 33.8645 19.0147 35.8803 22.5062C38.1815 26.4918 36.8158 31.5885 32.83 33.8897C29.4343 35.8502 25.2365 35.1487 22.6435 32.4373L25.0525 30.1335ZM6.33333 26.6673C6.33333 24.3183 7.95485 22.3438 10.1417 21.8098L9.35102 18.5717C5.70643 19.4615 3 22.7463 3 26.6673C3 31.2697 6.73097 35.0007 11.3333 35.0007C15.3649 35.0007 18.7278 32.1377 19.5 28.334H25.7738L25.7767 28.3392C26.6972 29.9335 28.7358 30.4797 30.3302 29.5592C31.9245 28.6387 32.4707 26.6002 31.5502 25.0058C30.6297 23.4115 28.5912 22.8652 26.9968 23.7857C26.7667 23.9185 26.5585 24.0747 26.3733 24.2493C25.9407 24.6577 25.4127 25.0007 24.8177 25.0007H16.3333V26.6673C16.3333 29.4288 14.0948 31.6673 11.3333 31.6673C8.57192 31.6673 6.33333 29.4288 6.33333 26.6673Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4136_524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 34,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5022 7.33125C24.5365 8.50579 25.4357 10.8973 24.8047 13.0582L28.0045 13.9925C29.056 10.3912 27.5645 6.405 24.1688 4.4445C20.183 2.14332 15.0865 3.50895 12.7853 7.49472C10.7695 10.9862 11.5674 15.33 14.4755 17.9005L11.3387 23.3335H11.3333C9.4924 23.3335 8 24.826 8 26.6668C8 28.5078 9.4924 30.0002 11.3333 30.0002C13.1743 30.0002 14.6667 28.5078 14.6667 26.6668C14.6667 26.4012 14.6356 26.1427 14.5768 25.8948C14.4395 25.3158 14.4064 24.687 14.7039 24.1715L18.9455 16.8248L17.5022 15.9915C15.1107 14.6108 14.2913 11.5529 15.6721 9.16139C17.0528 6.76992 20.1107 5.95055 22.5022 7.33125ZM25.0525 30.1335C26.6083 31.7603 29.129 32.1775 31.1633 31.0028C33.5548 29.6222 34.3742 26.5643 32.9935 24.1728C31.6128 21.7813 28.5548 20.962 26.1633 22.3427L24.72 23.176L20.4777 15.828C20.1802 15.3126 19.6188 15.0269 19.0488 14.8563C18.8048 14.7833 18.5655 14.681 18.3355 14.5481C16.7412 13.6276 16.1949 11.589 17.1153 9.9947C18.0358 8.40039 20.0745 7.85414 21.6688 8.77462C23.2632 9.69509 23.8093 11.7337 22.8888 13.328L22.886 13.3329L26.0235 18.767C29.7037 17.5337 33.8645 19.0147 35.8803 22.5062C38.1815 26.4918 36.8158 31.5885 32.83 33.8897C29.4343 35.8502 25.2365 35.1487 22.6435 32.4373L25.0525 30.1335ZM6.33333 26.6673C6.33333 24.3183 7.95485 22.3438 10.1417 21.8098L9.35102 18.5717C5.70643 19.4615 3 22.7463 3 26.6673C3 31.2697 6.73097 35.0007 11.3333 35.0007C15.3649 35.0007 18.7278 32.1377 19.5 28.334H25.7738L25.7767 28.3392C26.6972 29.9335 28.7358 30.4797 30.3302 29.5592C31.9245 28.6387 32.4707 26.6002 31.5502 25.0058C30.6297 23.4115 28.5912 22.8652 26.9968 23.7857C26.7667 23.9185 26.5585 24.0747 26.3733 24.2493C25.9407 24.6577 25.4127 25.0007 24.8177 25.0007H16.3333V26.6673C16.3333 29.4288 14.0948 31.6673 11.3333 31.6673C8.57192 31.6673 6.33333 29.4288 6.33333 26.6673Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4136_524)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_fn_4136_524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.77038,
    cy: 38.0702,
    rx: 24.3611,
    ry: 39.1926,
    transform: "rotate(-83.7236 7.77038 38.0702)",
    fill: "url(#paint0_linear_4136_524)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_nf_4136_524)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.999,
    cy: 11.1521,
    rx: 4.24023,
    ry: 4.23218,
    fill: "url(#paint1_linear_4136_524)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_4136_524",
    x: 3,
    y: 3.32666,
    width: 33.998,
    height: 31.6807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4136_524"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_fn_4136_524",
    x: -43.7803,
    y: 0.974609,
    width: 103.101,
    height: 74.1909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_4136_524"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_4136_524",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_4136_524"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_4136_524"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_nf_4136_524",
    x: 11.7588,
    y: 2.91992,
    width: 16.4805,
    height: 16.4644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2.6666667461395264 2.6666667461395264",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1050
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.1)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4136_524"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_4136_524"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4136_524",
    x1: 34.3475,
    y1: 54.7541,
    x2: 9.87001,
    y2: 41.6912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276417,
    stopColor: "#081681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583149,
    stopColor: "#0F9CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4136_524",
    x1: 19.999,
    y1: 6.91992,
    x2: 19.999,
    y2: 15.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC1503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon4);
export default __webpack_public_path__ + "static/media/caseIcon4.cdfb6e7910b8941fd974b9e6df668359.svg";
export { ForwardRef as ReactComponent };